import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "../components/analytics-service/analytics.service";

@Component({
  selector: "app-people",
  templateUrl: "./people.component.html",
  styleUrls: ["./people.component.scss"],
})
export class PeopleComponent implements OnInit {
  alumni = [
    // Past Members
    { name: "Jetlinda Krasniqi" },
    { name: "Bojana Chen" },
    { name: "Linda Stamm" },
    { name: "Kristina Djordjevic" },
    { name: "Anna Clorinda Raselli" },
    { name: "Boglárka Rácz" },
    { name: "Patrick Meier" },
    { name: "Dr. Eriberto Natali" },
    { name: "Roshin Chittilappilly" },
    { name: "Teyfik Agac" },
    { name: "Deniz Tosoni" },
    { name: "Dr. Lmar Babrak" },
    { name: "Raffael Kuhn" },
    { name: "Marc Stawiski" },
    { name: "Alexander Horst" },
    { name: "Erand Smakaj" },
    { name: "Christopher Galli" },
  ];
  people = [
    // Lab Members
    {
      name: "Prof. Dr. Enkelejda Miho",
      img: "../../assets/img/people/enkelejda_miho.jpg",
      role: "Principal Investigator",
      text:
        "<p>Prof. Dr. Enkelejda Miho is a full Professor of Digital Life Sciences at the Institute of Medical Engineering and Medical Informatics, School of Life Sciences, University of Applied Sciences and Arts Northwestern Switzerland. She is a group leader at Swiss Bioinformatics Institute and head of the Laboratory of Artificial Intelligence in Health. Her research focuses on the emerging field of artificial intelligence applied to health in order to inform personalized diagnostics and therapeutics, with a primary focus in adaptive immunity. Her group develops and applies artificial intelligence methods for (i) clinical support decision systems for precision diagnostics of infection, autoimmunity, rare diseases, and cancer, and (ii) antibody/nanobody discovery, library optimization. She collaborates with hospitals in CH and EU to integrate different data modalities into AI-supported medical software.</p>" +
        "<p>Prof. Miho holds a M.Sc. in Pharmaceutical Chemistry and Technology from the University of Bologna, a DAS in Pharmaceutical Medicine from the European Center of Pharmaceutical Medicine (ECPM), Faculty of Medicine, University of Basel and a Ph. D. from ETH Zurich at Biosystems Science and Engineering. She is the founder of the ETH spin-off aiNET.</p>",
      contact:
        "<li>" +
        "FHNW University of Applied Sciences and Arts Northwestern Switzerland<br>" +
        "School of Life Sciences<br>" +
        "Institute of Medical Engineering and Medical Informatics" +
        "</li>" +
        "<li>&nbsp;</li>" +
        "<li>" +
        "<strong>Prof. Dr. Enkelejda Miho</strong><br>" +
        "Professor of Digital Life Sciences<br>" +
        "Office 05.W.03<br>" +
        "Hofackerstrasse 30<br>" +
        "4132 Muttenz<br>" +
        "</li>" +
        "<li>&nbsp</li>" +
        '<li><i class="fa fa-envelope"></i> enkelejda.miho@fhnw.ch</li>' +
        '<li><i class="fa fa-phone"></i> (+41) 61 228 58 47</li>',
    },
    {
      name: "Jan Kruta",
      img: "../../assets/img/people/jan_kruta.jpg",
      role: "PhD Candidate",
      text:
        "<p>Jan Kruta joined the aiHealthLab at the University of Applied Sciences and Arts Northwestern Switzerland as a research assistant in 2022. He holds an MSc in Medical Informatics and is a PhD candidate in Cancer Biology with a focus on bioinformatics. </p>" +
        "<p>His research focuses on integrating multi-omics and clinical data with machine-learning methods to enhance diagnostic decision support.</p>",
      contact:
        "<li>" +
        "FHNW University of Applied Sciences and Arts Northwestern Switzerland<br>" +
        "School of Life Sciences<br>" +
        "Institute of Medical Engineering and Medical Informatics" +
        "</li>" +
        "<li>&nbsp;</li>" +
        "<li>" +
        "<strong>Jan Kruta</strong><br>" +
        "PhD Candidate<br>" +
        "Office 05.W<br>" +
        "Hofackerstrasse 30<br>" +
        "4132 Muttenz<br>" +
        "</li>" +
        "<li>&nbsp</li>" +
        '<li><i class="fa fa-envelope"></i> jan.kruta@fhnw.ch</li>',
    },
    {
      name: "Aurora Eliana Merulla",
      img: "../../assets/img/people/aurora_eliana_merulla.jpg",
      role: "Visiting PhD Student",
      text:
        "<p>Aurora Eliana Merulla is a visiting PhD student in the AI Health Lab at FHNW, working with Professor Enkelejda Miho. She is pursuing a PhD in Complex Systems for Physical, Socio-Economic, and Life Sciences within the COMBINE Group at the University of Catania. Her visiting research focuses on the development of immune digital twins, combining data-driven approaches with mechanistic modeling to support personalized and interpretable representations of immune responses.</p>" +
        "<p>She holds a Master's degree in Medical Biotechnology and a Second-level Professional Master's Degree in Bioinformatics from the University of Catania. Her scientific background combines molecular biology, bioinformatics, biological data analysis, and in silico modeling. She initially approached computational biology through the statistical and bioinformatic analysis of molecular data and subsequently specialized in biological network analysis and computational modeling of biological and pharmacological processes. She previously worked as a research fellow on bioinformatics applications to biological processes and in silico modeling.</p>",
      contact:
        "<li>" +
        "FHNW University of Applied Sciences and Arts Northwestern Switzerland<br>" +
        "School of Life Sciences<br>" +
        "Institute of Medical Engineering and Medical Informatics" +
        "</li>" +
        "<li>&nbsp;</li>" +
        "<li>" +
        "<strong>Aurora Eliana Merulla</strong><br>" +
        "Visiting PhD Student<br>" +
        "Office 05.W<br>" +
        "Hofackerstrasse 30<br>" +
        "4132 Muttenz<br>" +
        "</li>" +
        "<li>&nbsp</li>" +
        '<li><i class="fa fa-envelope"></i> aurora.merulla@fhnw.ch</li>',
    },
    {
      name: "Juliette Puglisi",
      img: "../../assets/img/people/juliette_puglisi.jpg",
      role: "Master's Student",
      text:
        "<p>Juliette Puglisi is a Master's student in Data Science at the FHNW School of Life Sciences, currently working on her Master's thesis with Professor Enkelejda Miho. Her research focuses on the comparative genomic characterization of a proprietary commensal bacterial strain to demonstrate its genomic distinctiveness from publicly available reference strains. To achieve this, she is developing a bioinformatics workflow that integrates structural genome annotation, pan-genome analysis, and variant discovery.</p>" +
        "<p>She holds a Bachelor of Life Science in Bioanalytics and Cell Biology from FHNW (2024). Her scientific background bridges the gap between the laboratory and computational science, combining biology and clinical diagnostics with programming. Prior to starting her thesis, Juliette completed an internship at Roche in the pRED center ADME automation team (2025-2026), where she focused on creating data processing workflows and programming liquid handling robots. She also completed an internship at the University Hospital of Basel (2023-2024), where she implemented sequencing quality control scripts into the hospital's Laboratory Information System. Earlier in her career, she gained extensive hands-on laboratory experience through internships at the Cantonal Hospital of Basel-Country.</p>",
      contact:
        "<li>" +
        "FHNW University of Applied Sciences and Arts Northwestern Switzerland<br>" +
        "School of Life Sciences<br>" +
        "Institute of Medical Engineering and Medical Informatics" +
        "</li>" +
        "<li>&nbsp;</li>" +
        "<li>" +
        "<strong>Juliette Puglisi</strong><br>" +
        "Master's Student<br>" +
        "Office 05.W<br>" +
        "Hofackerstrasse 30<br>" +
        "4132 Muttenz<br>" +
        "</li>" +
        "<li>&nbsp</li>" +
        '<li><i class="fa fa-envelope"></i> juliette.puglisi@fhnw.ch</li>',
    },
    {
      name: "Doina Rey",
      img: "../../assets/img/people/doina_rey.jpg",
      role: "Master's Student",
      text:
        "<p>Doina Rey is a Master’s student in Biomedical Engineering at the FHNW School of Life Sciences and the University of Basel, with the specialization track of image acquisition and analysis. She is currently working on a Semester's thesis with Professor Enkelejda Miho. Her research aims to establish a method to integrate public available omics, clinical, and imaging data to support machine learning-based diagnosis of systemic light-chain (AL) amyloidosis.</p>" +
        "<p>She holds a Bachelor of Science in Chemistry from ETH Zurich (2024). During her studies, she developed a strong interest in medical imaging and its diagnostic applications, which led her to choose her master specialization track. Prior to starting her semester thesis, she completed a research internship at the University of Basel (2026), where she labelled MS lesions in MRI scans and wrote small image-processing programs to analyse and quantify her findings.</p>",
      contact:
        "<li>" +
        "FHNW University of Applied Sciences and Arts Northwestern Switzerland<br>" +
        "School of Life Sciences<br>" +
        "Institute of Medical Engineering and Medical Informatics" +
        "</li>" +
        "<li>&nbsp;</li>" +
        "<li>" +
        "<strong>Doina Rey</strong><br>" +
        "Master's Student<br>" +
        "Office 05.W<br>" +
        "Hofackerstrasse 30<br>" +
        "4132 Muttenz<br>" +
        "</li>" +
        "<li>&nbsp</li>" +
        '<li><i class="fa fa-envelope"></i> doina.rey@students.fhnw.ch</li>',
    },
    {
      name: "Nicolas Bopp",
      img: "../../assets/img/people/nicolas_bopp.jpg",
      role: "Scientific Assistant",
      text:
        "<p>Nicolas Bopp is a scientific assistant in the aiHealthLab at FHNW, where he has been working since October 2024. His work focuses on the development of a clinical decision support system (CDSS) for the diagnosis of AL amyloidosis within the European EUREKA consortium. In this role, he contributes as a full-stack developer, combining medical informatics and software engineering to create digital health solutions that support clinical decision-making. </p>" +
        "<p>He is also pursuing a Master of Science in Medical Informatics at FHNW, building on his Bachelor’s degree in Life Sciences with a specialization in Medical Informatics. His academic and professional path reflects a strong interest in leveraging technology and data science to improve healthcare and patient outcomes.</p>",
      contact:
        "<li>" +
        "FHNW University of Applied Sciences and Arts Northwestern Switzerland<br>" +
        "School of Life Sciences<br>" +
        "Institute of Medical Engineering and Medical Informatics" +
        "</li>" +
        "<li>&nbsp;</li>" +
        "<li>" +
        "<strong>Nicolas Bopp</strong><br>" +
        "Scientific Assistant<br>" +
        "Office 05.W<br>" +
        "Hofackerstrasse 30<br>" +
        "4132 Muttenz<br>" +
        "</li>" +
        "<li>&nbsp</li>" +
        '<li><i class="fa fa-envelope"></i> nicolas.bopp@fhnw.ch</li>',
    },
  ];

  selectedPerson: any;

  constructor(private analyticsService: AnalyticsService) {
    this.analyticsService.emitEvent("Page visit", "People");
  }

  ngOnInit() {
    this.setActive(this.people[0]);
  }

  setActive(i) {
    this.selectedPerson = i;
    this.analyticsService.emitEvent(
      "Page visit",
      "Person " + this.selectedPerson.name,
    );
  }
}
